import { style } from '@vanilla-extract/css'

const button = style({
  display: 'block',
  background: `
    linear-gradient(180deg, rgba(228, 99, 39, 0) 0%, #DB4D0B 100%),
    linear-gradient(0deg, #E46327, #E46327)
  `,
  padding: '16px 24px',
  borderRadius: '32px',
  width: '100%',
  color: 'white',
  textAlign: 'center',
  textDecoration: 'none',
  selectors: {
    '&[aria-disabled="true"]': {
      background: 'rgba(228, 99, 39, 0.5)',
      cursor: 'not-allowed',
    },
  },
})

const title = style({
  fontFamily: 'Noto Sans Variable, sans-serif',
  fontWeight: '700',
  fontSize: '18px',
  lineHeight: '1.5',
})

const subtitle = style({
  fontFamily: 'Noto Sans Variable, sans-serif',
  fontWeight: '700',
  fontSize: '13px',
  lineHeight: '1.5',
})

export const styles = {
  button,
  title,
  subtitle,
}
